import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { defaultLanguage } from "../components/core/localization/localizationUtils";

const namespaces = [
  "common",
  "authCapture",
  "authentication",
  "booking",
  "contactForm",
  "cookies",
  "enums",
  "errorPages",
  "events",
  "invoices",
  "layout",
  "backend",
  "navigationData",
  "organization",
  "participationTypes",
  "snackbars",
  "validations",
];

const i18nDebug = process.env.REACT_APP_I18N_DEBUG ?? "false";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: i18nDebug,
    fallbackLng: defaultLanguage.value,
    load: "languageOnly",
    ns: namespaces,
    defaultNS: "common",
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/static/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
